import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { loginApi } from "./authApi";

export const loginRequest = createAsyncThunk(
  "loginRequest/auth",
  async (payload: any) => {
    try {
      const response = await loginApi(payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  }
);

interface IInitialState {
  loginData: any;
  isLogin: boolean;
  token: string;
  tokenRefresh: string;
  pageIsLoading: boolean;
  message: string;
}

const initialState: IInitialState = {
  loginData: JSON.parse(localStorage.getItem("loginData") || "{}"),
  isLogin: JSON.parse(localStorage.getItem("isLogin") || "false"),
  token: localStorage.getItem("token") || "",
  tokenRefresh: localStorage.getItem("tokenRefresh") || "",
  pageIsLoading: false,
  message: "",
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    logout: (state) => {
      localStorage.removeItem("isLogin");
      localStorage.removeItem("token");
      localStorage.removeItem("tokenRefresh");
      localStorage.removeItem("loginData");
      state.isLogin = false;
      state.loginData = {};
      state.token = "";
      state.tokenRefresh = "";
      state.pageIsLoading = false;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(loginRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(loginRequest.fulfilled, (state, action) => {
      if (action.payload.status !== 1000) {
        state.pageIsLoading = false;
        state.message = action.payload.message;
      } else {
        state.isLogin = true;
        state.loginData = {
          employeeId: action.payload.data.employeeId,
          roles: action.payload.data.roles,
          activity: action.payload.data.activity,
        };
        state.token = action.payload.data.token;
        state.tokenRefresh = action.payload.data.tokenRefresh;
        state.message = "";
        state.pageIsLoading = false;
        localStorage.setItem(
          "loginData",
          JSON.stringify({
            employeeId: action.payload.data.employeeId,
            roles: action.payload.data.roles,
            activity: action.payload.data.activity,
          })
        );
        localStorage.setItem("isLogin", "true");
        localStorage.setItem("token", action.payload.data.token);
        localStorage.setItem("tokenRefresh", action.payload.data.tokenRefresh);
      }
    });
    builder.addCase(loginRequest.rejected, (state) => {
      state.message = "Login is Failed";
      state.pageIsLoading = false;
    });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
